import { render, staticRenderFns } from "./FetchWaybill.vue?vue&type=template&id=6b52c958&scoped=true&"
import script from "./FetchWaybill.vue?vue&type=script&lang=js&"
export * from "./FetchWaybill.vue?vue&type=script&lang=js&"
import style0 from "./FetchWaybill.vue?vue&type=style&index=0&id=6b52c958&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52c958",
  null
  
)

export default component.exports